// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3kkpz","signatureButtonsRight":"ModalSign_signatureButtonsRight__2tTcV"};